// 炫景广告
import React, { useEffect, useState } from 'react'

import { sendTeaAdEvent } from 'lib/tea-analyze'
import { useAdStat } from 'Components/ad'
import Label from './label'
import { setClose, isClosed } from './close'
import { DazzlingBannerAd } from './interface'
import applyHttpsImage from 'lib/apply-https-img'
export default function XuanjingAd({ data }: { data: DazzlingBannerAd }) {
  const [isShow, setIsShow] = useState(true)
  const [type, setType] = useState<'small' | 'big'>()

  const adData = {
    ad_material_id: data.materiel_str,
    ad_target_url: data.web_url,
    log_extra: data.log_extra,
    ad_id: data.id_str,
    ad_req_id: JSON.parse(data.log_extra).req_id,
  }
  const { ref, handleClick } = useAdStat(
    {
      send: 'ad_send_background_and_banner',
      show: 'ad_show_background_and_banner',
      click: 'ad_click_background_and_banner',
    },
    data,
    undefined,
    1000
  )
  useEffect(() => {
    const width = document.documentElement.clientWidth
    setType(width > 1440 ? 'big' : 'small')
    setIsShow(!isClosed('xuanjing', data.id_str))
  }, [data.id_str])
  if (!data) return null
  // if (!isShow) return null
  const imageLeft =
    type === 'small' ? data.image_left_small : data.image_left_big
  const imageRight =
    type === 'small' ? data.image_right_small : data.image_right_big

  return (
    <div>
      {isShow && (
        <a
          className="banner"
          onClick={() => {
            handleClick()
            window.open(data.web_url, '_blank')
          }}
          ref={ref}
        >
          <Label text={data.label} />
        </a>
      )}
      {isShow && (
        <div
          className={type === 'small' ? 'left small' : 'left big'}
          onClick={() => {
            handleClick()
            window.open(data.web_url, '_blank')
          }}
        />
      )}
      {isShow && (
        <div
          className={type === 'small' ? 'right small' : 'right big'}
          onClick={() => {
            handleClick()
            window.open(data.web_url, '_blank')
          }}
        />
      )}
      {isShow && (
        <span
          role="button"
          className="button close"
          onClick={() => {
            sendTeaAdEvent('ad_dislike_background_and_banner', adData)
            setClose('xuanjing', data.id_str)
            setIsShow(false)
          }}
        >
          <i className="icon-dislike-ic" />
        </span>
      )}
      {/* <style jsx global>
        {`
          .banner-enter {
            max-height: 0;
          }
          .banner-enter-active {
            max-height: 110px;
            transition: max-height 2000ms;
          }
          .banner-exit {
            max-height: 110px;
          }
          .banner-exit-active {
            max-height: 0;

            transition: max-height 2000ms;
          }
        `}
      </style> */}
      <style jsx>
        {`
          .banner {
            position: relative;
            display: block;
            height: 90px;
            width: 1196px;
            margin: 10px 0;
            border-radius: 2px;
            background: url(${applyHttpsImage(data.image_banner.url)}) 0 0
              no-repeat;
            background-size: 100% 100%;
          }
          .left,
          .right {
            position: absolute;
            top: -10px;
            cursor: pointer;
            border-radius: 2px;
            background-size: 100% 100%;
          }
          img {
            width: 100%;
          }
          .left {
            right: 1212px;
            margin-left: 16px;
            top: -130px;
            width: 365px;
            height: 602px;
            background: url(${applyHttpsImage(imageLeft.url)}) right center
              no-repeat;
            background-size: 100% 100%;
          }
          .right {
            left: 1212px;
            top: -130px;
            width: 365px;
            height: 602px;
            background: url(${applyHttpsImage(imageRight.url)}) left center
              no-repeat;
            background-size: 100% 100%;
          }
          .left.small,
          .right.small {
            width: 125px;
            height: 482px;
          }
          .button {
            position: absolute;
            top: 10px;
            right: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 18px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            color: #fff;
            cursor: pointer;
            border-radius: 9px;
            background: rgba(0, 0, 0, 0.3);
          }
          @media screen and (max-width: 1366px) {
            .left,
            .right {
              display: none;
            }
          }
        `}
      </style>
    </div>
  )
}
